import React from 'react';
import PropTypes from 'prop-types';
import Divider from "semantic-ui-react/dist/es/elements/Divider/Divider.js";
import classnames from 'classnames';
import { getIsSizeLarge } from "./utils/getIsSizeLarge";
export var Component = function Component(_ref) {
  var className = _ref.className,
      hasLine = _ref.hasLine,
      size = _ref.size;
  return React.createElement(Divider, {
    className: classnames(className, {
      'is-size-small': size === 'small',
      'is-size-huge': size === 'huge'
    }),
    hidden: !hasLine,
    section: getIsSizeLarge(size)
  });
};
Component.displayName = 'Divider';
Component.defaultProps = {
  className: '',
  hasLine: false,
  size: 'medium'
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  hasLine: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'huge'])
} : {};